import { NgModule } from '@angular/core';
import { NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';

import { NProgressBarComponent } from './n-progress-bar.component';

const components = [NProgressBarComponent];

@NgModule({
  declarations: components,
  exports: [components],
  imports: [NgbProgressbarModule],
})
export class ProgressBarModule {}
